<div class="page-header">
    <div class="col-12">
        <h1>WIP Report <small>Summary of Contracts PMs</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row action-toolbar" style="margin-top: 15px">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="wipGrid"></action-toolbar-count>
                <grid-export [grid]="gridWip" [name]="'Job Scheduling'"></grid-export>

                <div class="input-header-group">
                    <span class="input-header">WIP Month</span>
                    <wj-input-date
                        [(ngModel)]="wipMonth"
                        class="header-input"
                        name="wipMonth"
                        (ngModelChange)="refresh()"
                        [selectionMode]="'Month'"
                        [format]="'MMM yyyy'"
                    ></wj-input-date>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Job Status</span>
                    <wj-multi-select
                        name="jobActvityType"
                        (checkedItemsChanged)="refresh()"
                        [itemsSource]="activeMap"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Project Manager</span>
                    <wj-combo-box
                        [(ngModel)]="selectedPm"
                        class="header-input"
                        style="width: 200px"
                        name="selectedPm"
                        [itemsSource]="pmList"
                        [isEditable]="false"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (ngModelChange)="refresh()"
                    >
                    </wj-combo-box>
                </div>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <wj-flex-grid
                id="gridWip"
                #gridWip
                appAutoSize
                [padding]="73"
                (initialized)="wipGrid.initialize(gridWip)"
                [itemsSource]="wipGrid.view"
                [itemFormatter]="gridItemFormatter"
                [keyActionTab]="'CycleEditable'"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column
                    [header]="'Contract Job Description'"
                    [binding]="'jobName'"
                    [minWidth]="350"
                    [width]="'*'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Total Contract'"
                    [binding]="'finalPrice'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Contract Cost TD'"
                    [binding]="'costToDate'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Est Cost to Complete'"
                    [binding]="'costToComplete'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Est Total Cost'"
                    [binding]="'estTotalCost'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Est Gross Profit'"
                    [binding]="'estGrossProfit'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Est Gross Profit %'"
                    [binding]="'estGrossProfitPercent'"
                    [width]="130"
                    [format]="'P2'"
                    [aggregate]="'Avg'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Percent Complete'"
                    [binding]="'percentComplete'"
                    [width]="130"
                    [format]="'P2'"
                    [aggregate]="'Avg'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Gain (Fade) From Prior Mth'"
                    [binding]="'gainFade'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Billings To Date'"
                    [binding]="'billingsToDate'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'(Over) / Under Billings'"
                    [binding]="'costInExcess'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Contract Revenues Earned'"
                    [binding]="'contractRevenuesEarned'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Gross Profit (Loss) TD'"
                    [binding]="'grossProfitLoss'"
                    [width]="130"
                    [format]="'C0'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Gross Profit % TD'"
                    [binding]="'grossProfitPercent'"
                    [width]="130"
                    [format]="'P2'"
                    [aggregate]="'Avg'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
            <grid-selection-calculation [grid]="gridWip"></grid-selection-calculation>
        </div>
    </div>
</div>
